import { Component, computed, inject, input } from '@angular/core';
import { DocumentItemPartial } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { EditDataService } from '../../../services/_edit-data.service';
import { EditService } from '../../../services/edit-service';
import { InlineTextEditorComponent } from './inline-text-editor/inline-text-editor.component';

/**
 * Área de descrição dos cards de mídia (imagem, grupo, vídeo): o texto é editado direto
 * no card pelo `inline-text-editor` (salva em `item.description`). Tamanho e cor da
 * descrição vêm da barra do topo do editor, como qualquer texto.
 */
@Component({
    selector: 'card-description-area',
    templateUrl: 'card-description-area.component.html',
    styleUrl: 'card-description-area.component.scss',
    imports: [InlineTextEditorComponent, TranslatePipe],
})
export class CardDescriptionAreaComponent {
    public field = input.required<DocumentItemPartial>();
    /** Lixeira e favoritos: só leitura. */
    public readonly = input(false);

    public editService = inject(EditService);
    public editDataService = inject(EditDataService);

    public blocked = computed(
        () =>
            this.editService.loading() ||
            this.editDataService.currentSessionIsDisabled() ||
            this.editDataService.documentIsBlocked()
    );

    /** True quando a descrição tem conteúdo de texto/mídia (não é Delta vazio). */
    public hasDescription(): boolean {
        return !this._isDeltaEmpty(this.field().description);
    }

    private _isDeltaEmpty(value: unknown): boolean {
        if (value == null) return true;

        if (typeof value !== 'string') {
            return this._opsEmpty((value as { ops?: unknown[] })?.ops);
        }

        const str = value.trim();
        if (!str) return true;

        try {
            const parsed = JSON.parse(str) as { ops?: unknown[] };
            return this._opsEmpty(parsed.ops);
        } catch {
            return str.length === 0;
        }
    }

    private _opsEmpty(ops?: unknown[]): boolean {
        if (!Array.isArray(ops)) return true;

        for (const op of ops) {
            const insert = (op as { insert?: unknown }).insert;
            if (typeof insert === 'string') {
                if (insert.replace(/\n/g, '').trim().length > 0) return false;
            } else if (insert != null) {
                // Embed (imagem, tag de dados etc.) conta como conteúdo
                return false;
            }
        }

        return true;
    }
}
